import React from "react";
import * as S from "./styles";
export var RightArrow = function RightArrow(t) {
  return React.createElement(S.SVG, Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7 14",
    "aria-hidden": "true"
  }, t), React.createElement("path", {
    d: "M6 7l-6 6.5V.5z"
  }));
};